"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobPortalNocCodeValueLabel = void 0;
exports.jobPortalNocCodeValueLabel = [
    {
        value: "00010 - Legislators",
        label: "00010 - Legislators",
    },
    {
        value: "00011 - Senior government managers and officials",
        label: "00011 - Senior government managers and officials",
    },
    {
        value: "00012 - Senior managers - financial, communications and other business services",
        label: "00012 - Senior managers - financial, communications and other business services",
    },
    {
        value: "00013 - Senior managers - health, education, social and community services and membership organizations",
        label: "00013 - Senior managers - health, education, social and community services and membership organizations",
    },
    {
        value: "00014 - Senior managers - trade, broadcasting and other services",
        label: "00014 - Senior managers - trade, broadcasting and other services",
    },
    {
        value: "00015 - Senior managers - construction, transportation, production and utilities",
        label: "00015 - Senior managers - construction, transportation, production and utilities",
    },
    {
        value: "10010 - Financial managers",
        label: "10010 - Financial managers",
    },
    {
        value: "10011 - Human resources managers",
        label: "10011 - Human resources managers",
    },
    {
        value: "10012 - Purchasing managers",
        label: "10012 - Purchasing managers",
    },
    {
        value: "10019 - Other administrative services managers",
        label: "10019 - Other administrative services managers",
    },
    {
        value: "10020 - Insurance, real estate and financial brokerage managers",
        label: "10020 - Insurance, real estate and financial brokerage managers",
    },
    {
        value: "10021 - Banking, credit and other investment managers",
        label: "10021 - Banking, credit and other investment managers",
    },
    {
        value: "10022 - Advertising, marketing and public relations managers",
        label: "10022 - Advertising, marketing and public relations managers",
    },
    {
        value: "10029 - Other business services managers",
        label: "10029 - Other business services managers",
    },
    {
        value: "10030 - Telecommunication carriers managers",
        label: "10030 - Telecommunication carriers managers",
    },
    {
        value: "11100 - Financial auditors and accountants",
        label: "11100 - Financial auditors and accountants",
    },
    {
        value: "11101 - Financial and investment analysts",
        label: "11101 - Financial and investment analysts",
    },
    {
        value: "11102 - Financial advisors",
        label: "11102 - Financial advisors",
    },
    {
        value: "11103 - Securities agents, investment dealers and brokers",
        label: "11103 - Securities agents, investment dealers and brokers",
    },
    {
        value: "11109 - Other financial officers",
        label: "11109 - Other financial officers",
    },
    {
        value: "11200 - Human resources professionals",
        label: "11200 - Human resources professionals",
    },
    {
        value: "11201 - Professional occupations in business management consulting",
        label: "11201 - Professional occupations in business management consulting",
    },
    {
        value: "11202 - Professional occupations in advertising, marketing and public relations",
        label: "11202 - Professional occupations in advertising, marketing and public relations",
    },
    {
        value: "12010 - Supervisors, general office and administrative support workers",
        label: "12010 - Supervisors, general office and administrative support workers",
    },
    {
        value: "12011 - Supervisors, finance and insurance office workers",
        label: "12011 - Supervisors, finance and insurance office workers",
    },
    {
        value: "12012 - Supervisors, library, correspondence and related information workers",
        label: "12012 - Supervisors, library, correspondence and related information workers",
    },
    {
        value: "12013 - Supervisors, supply chain, tracking and scheduling coordination occupations",
        label: "12013 - Supervisors, supply chain, tracking and scheduling coordination occupations",
    },
    {
        value: "12100 - Executive assistants",
        label: "12100 - Executive assistants",
    },
    {
        value: "12101 - Human resources and recruitment officers",
        label: "12101 - Human resources and recruitment officers",
    },
    {
        value: "12102 - Procurement and purchasing agents and officers",
        label: "12102 - Procurement and purchasing agents and officers",
    },
    {
        value: "12103 - Conference and event planners",
        label: "12103 - Conference and event planners",
    },
    {
        value: "12104 - Employment insurance and revenue officers",
        label: "12104 - Employment insurance and revenue officers",
    },
    {
        value: "12110 - Court reporters, medical transcriptionists and related occupations",
        label: "12110 - Court reporters, medical transcriptionists and related occupations",
    },
    {
        value: "12111 - Health information management occupations",
        label: "12111 - Health information management occupations",
    },
    {
        value: "12112 - Records management technicians",
        label: "12112 - Records management technicians",
    },
    {
        value: "12113 - Statistical officers and related research support occupations",
        label: "12113 - Statistical officers and related research support occupations",
    },
    {
        value: "12200 - Accounting technicians and bookkeepers",
        label: "12200 - Accounting technicians and bookkeepers",
    },
    {
        value: "12201 - Insurance adjusters and claims examiners",
        label: "12201 - Insurance adjusters and claims examiners",
    },
    {
        value: "12202 - Insurance underwriters",
        label: "12202 - Insurance underwriters",
    },
    {
        value: "12203 - Assessors, business valuators and appraisers",
        label: "12203 - Assessors, business valuators and appraisers",
    },
    {
        value: "13100 - Administrative officers",
        label: "13100 - Administrative officers",
    },
    {
        value: "13101 - Property administrators",
        label: "13101 - Property administrators",
    },
    {
        value: "13102 - Payroll administrators",
        label: "13102 - Payroll administrators",
    },
    {
        value: "13110 - Administrative assistants",
        label: "13110 - Administrative assistants",
    },
    {
        value: "13111 - Legal administrative assistants",
        label: "13111 - Legal administrative assistants",
    },
    {
        value: "13112 - Medical administrative assistants",
        label: "13112 - Medical administrative assistants",
    },
    {
        value: "13200 - Customs, ship and other brokers",
        label: "13200 - Customs, ship and other brokers",
    },
    {
        value: "13201 - Production and transportation logistics coordinators",
        label: "13201 - Production and transportation logistics coordinators",
    },
    {
        value: "14100 - General office support workers",
        label: "14100 - General office support workers",
    },
    {
        value: "14101 - Receptionists",
        label: "14101 - Receptionists",
    },
    {
        value: "14102 - Personnel clerks",
        label: "14102 - Personnel clerks",
    },
    {
        value: "14103 - Court clerks and related court services occupations",
        label: "14103 - Court clerks and related court services occupations",
    },
    {
        value: "14110 - Survey interviewers and statistical clerks",
        label: "14110 - Survey interviewers and statistical clerks",
    },
    {
        value: "14111 - Data entry clerks",
        label: "14111 - Data entry clerks",
    },
    {
        value: "14112 - Desktop publishing operators and related occupations",
        label: "14112 - Desktop publishing operators and related occupations",
    },
    {
        value: "14200 - Accounting and related clerks",
        label: "14200 - Accounting and related clerks",
    },
    {
        value: "14201 - Banking, insurance and other financial clerks",
        label: "14201 - Banking, insurance and other financial clerks",
    },
    {
        value: "14202 - Collection clerks",
        label: "14202 - Collection clerks",
    },
    {
        value: "14300 - Library assistants and clerks",
        label: "14300 - Library assistants and clerks",
    },
    {
        value: "14301 - Correspondence, publication and regulatory clerks",
        label: "14301 - Correspondence, publication and regulatory clerks",
    },
    {
        value: "14400 - Shippers and receivers",
        label: "14400 - Shippers and receivers",
    },
    {
        value: "14401 - Storekeepers and partspersons",
        label: "14401 - Storekeepers and partspersons",
    },
    {
        value: "14402 - Production logistics workers",
        label: "14402 - Production logistics workers",
    },
    {
        value: "14403 - Purchasing and inventory control workers",
        label: "14403 - Purchasing and inventory control workers",
    },
    {
        value: "14404 - Dispatchers",
        label: "14404 - Dispatchers",
    },
    {
        value: "14405 - Transportation route and crew schedulers",
        label: "14405 - Transportation route and crew schedulers",
    },
    {
        value: "20010 - Engineering managers",
        label: "20010 - Engineering managers",
    },
    {
        value: "20011 - Architecture and science managers",
        label: "20011 - Architecture and science managers",
    },
    {
        value: "20012 - Computer and information systems managers",
        label: "20012 - Computer and information systems managers",
    },
    {
        value: "21100 - Physicists and astronomers",
        label: "21100 - Physicists and astronomers",
    },
    {
        value: "21101 - Chemists",
        label: "21101 - Chemists",
    },
    {
        value: "21102 - Geoscientists and oceanographers",
        label: "21102 - Geoscientists and oceanographers",
    },
    {
        value: "21103 - Meteorologists and climatologists",
        label: "21103 - Meteorologists and climatologists",
    },
    {
        value: "21109 - Other professional occupations in physical sciences",
        label: "21109 - Other professional occupations in physical sciences",
    },
    {
        value: "21110 - Biologists and related scientists",
        label: "21110 - Biologists and related scientists",
    },
    {
        value: "21111 - Forestry professionals",
        label: "21111 - Forestry professionals",
    },
    {
        value: "21112 - Agricultural representatives, consultants and specialists",
        label: "21112 - Agricultural representatives, consultants and specialists",
    },
    {
        value: "21120 - Public and environmental health and safety professionals ",
        label: "21120 - Public and environmental health and safety professionals",
    },
    {
        value: "21200 - Architects",
        label: "21200 - Architects",
    },
    {
        value: "21201 - Landscape architects",
        label: "21201 - Landscape architects",
    },
    {
        value: "21202 - Urban and land use planners",
        label: "21202 - Urban and land use planners",
    },
    {
        value: "21203 - Land surveyors",
        label: "21203 - Land surveyors",
    },
    {
        value: "21210 - Mathematicians, statisticians and actuaries",
        label: "21210 - Mathematicians, statisticians and actuaries",
    },
    {
        value: "21211 - Data scientists ",
        label: "21211 - Data scientists",
    },
    {
        value: "21220 - Cybersecurity specialists ",
        label: "21220 - Cybersecurity specialists",
    },
    {
        value: "21221 - Business systems specialists",
        label: "21221 - Business systems specialists",
    },
    {
        value: "21222 - Information systems specialists",
        label: "21222 - Information systems specialists",
    },
    {
        value: "21223 - Database analysts and data administrators",
        label: "21223 - Database analysts and data administrators",
    },
    {
        value: "21230 - Computer systems developers and programmers ",
        label: "21230 - Computer systems developers and programmers",
    },
    {
        value: "21231 - Software engineers and designers",
        label: "21231 - Software engineers and designers",
    },
    {
        value: "21232 - Software developers and programmers ",
        label: "21232 - Software developers and programmers",
    },
    {
        value: "21233 - Web designers",
        label: "21233 - Web designers",
    },
    {
        value: "21234 - Web developers and programmers ",
        label: "21234 - Web developers and programmers",
    },
    {
        value: "21300 - Civil engineers",
        label: "21300 - Civil engineers",
    },
    {
        value: "21301 - Mechanical engineers",
        label: "21301 - Mechanical engineers",
    },
    {
        value: "21310 - Electrical and electronics engineers",
        label: "21310 - Electrical and electronics engineers",
    },
    {
        value: "21311 - Computer engineers (except software engineers and designers)",
        label: "21311 - Computer engineers (except software engineers and designers)",
    },
    {
        value: "21320 - Chemical engineers",
        label: "21320 - Chemical engineers",
    },
    {
        value: "21321 - Industrial and manufacturing engineers",
        label: "21321 - Industrial and manufacturing engineers",
    },
    {
        value: "21322 - Metallurgical and materials engineers",
        label: "21322 - Metallurgical and materials engineers",
    },
    {
        value: "21330 - Mining engineers",
        label: "21330 - Mining engineers",
    },
    {
        value: "21331 - Geological engineers ",
        label: "21331 - Geological engineers",
    },
    {
        value: "21332 - Petroleum engineers",
        label: "21332 - Petroleum engineers",
    },
    {
        value: "21390 - Aerospace engineers",
        label: "21390 - Aerospace engineers",
    },
    {
        value: "21399 - Other professional engineers",
        label: "21399 - Other professional engineers",
    },
    {
        value: "22100 - Chemical technologists and technicians",
        label: "22100 - Chemical technologists and technicians",
    },
    {
        value: "22101 - Geological and mineral technologists and technicians",
        label: "22101 - Geological and mineral technologists and technicians",
    },
    {
        value: "22110 - Biological technologists and technicians",
        label: "22110 - Biological technologists and technicians",
    },
    {
        value: "22111 - Agricultural and fish products inspectors",
        label: "22111 - Agricultural and fish products inspectors",
    },
    {
        value: "22112 - Forestry technologists and technicians",
        label: "22112 - Forestry technologists and technicians",
    },
    {
        value: "22113 - Conservation and fishery officers",
        label: "22113 - Conservation and fishery officers",
    },
    {
        value: "22114 - Landscape and horticulture technicians and specialists",
        label: "22114 - Landscape and horticulture technicians and specialists",
    },
    {
        value: "22210 - Architectural technologists and technicians",
        label: "22210 - Architectural technologists and technicians",
    },
    {
        value: "22211 - Industrial designers",
        label: "22211 - Industrial designers",
    },
    {
        value: "22212 - Drafting technologists and technicians",
        label: "22212 - Drafting technologists and technicians",
    },
    {
        value: "22213 - Land survey technologists and technicians",
        label: "22213 - Land survey technologists and technicians",
    },
    {
        value: "22214 - Technical occupations in geomatics and meteorology",
        label: "22214 - Technical occupations in geomatics and meteorology",
    },
    {
        value: "22220 - Computer network and web technicians",
        label: "22220 - Computer network and web technicians",
    },
    {
        value: "22221 - User support technicians",
        label: "22221 - User support technicians",
    },
    {
        value: "22222 - Information systems testing technicians",
        label: "22222 - Information systems testing technicians",
    },
    {
        value: "22230 - Non-destructive testers and inspectors",
        label: "22230 - Non-destructive testers and inspectors",
    },
    {
        value: "22231 - Engineering inspectors and regulatory officers",
        label: "22231 - Engineering inspectors and regulatory officers",
    },
    {
        value: "22232 - Occupational health and safety specialists",
        label: "22232 - Occupational health and safety specialists",
    },
    {
        value: "22233 - Construction inspectors",
        label: "22233 - Construction inspectors",
    },
    {
        value: "22300 - Civil engineering technologists and technicians",
        label: "22300 - Civil engineering technologists and technicians",
    },
    {
        value: "22301 - Mechanical engineering technologists and technicians",
        label: "22301 - Mechanical engineering technologists and technicians",
    },
    {
        value: "22302 - Industrial engineering and manufacturing technologists and technicians",
        label: "22302 - Industrial engineering and manufacturing technologists and technicians",
    },
    {
        value: "22303 - Construction estimators",
        label: "22303 - Construction estimators",
    },
    {
        value: "22310 - Electrical and electronics engineering technologists and technicians",
        label: "22310 - Electrical and electronics engineering technologists and technicians",
    },
    {
        value: "22311 - Electronic service technicians (household and business equipment)",
        label: "22311 - Electronic service technicians (household and business equipment)",
    },
    {
        value: "22312 - Industrial instrument technicians and mechanics",
        label: "22312 - Industrial instrument technicians and mechanics",
    },
    {
        value: "22313 - Aircraft instrument, electrical and avionics mechanics, technicians and inspectors",
        label: "22313 - Aircraft instrument, electrical and avionics mechanics, technicians and inspectors",
    },
    {
        value: "30010 - Managers in health care",
        label: "30010 - Managers in health care",
    },
    {
        value: "31100 - Specialists in clinical and laboratory medicine",
        label: "31100 - Specialists in clinical and laboratory medicine",
    },
    {
        value: "31101 - Specialists in surgery ",
        label: "31101 - Specialists in surgery",
    },
    {
        value: "31102 - General practitioners and family physicians",
        label: "31102 - General practitioners and family physicians",
    },
    {
        value: "31103 - Veterinarians",
        label: "31103 - Veterinarians",
    },
    {
        value: "31110 - Dentists",
        label: "31110 - Dentists",
    },
    {
        value: "31111 - Optometrists",
        label: "31111 - Optometrists",
    },
    {
        value: "31112 - Audiologists and speech-language pathologists",
        label: "31112 - Audiologists and speech-language pathologists",
    },
    {
        value: "31120 - Pharmacists",
        label: "31120 - Pharmacists",
    },
    {
        value: "31121 - Dietitians and nutritionists",
        label: "31121 - Dietitians and nutritionists",
    },
    {
        value: "31200 - Psychologists",
        label: "31200 - Psychologists",
    },
    {
        value: "31201 - Chiropractors",
        label: "31201 - Chiropractors",
    },
    {
        value: "31202 - Physiotherapists",
        label: "31202 - Physiotherapists",
    },
    {
        value: "31203 - Occupational therapists",
        label: "31203 - Occupational therapists",
    },
    {
        value: "31204 - Kinesiologists and other professional occupations in therapy and assessment",
        label: "31204 - Kinesiologists and other professional occupations in therapy and assessment",
    },
    {
        value: "31209 - Other professional occupations in health diagnosing and treating",
        label: "31209 - Other professional occupations in health diagnosing and treating",
    },
    {
        value: "31300 - Nursing coordinators and supervisors",
        label: "31300 - Nursing coordinators and supervisors",
    },
    {
        value: "31301 - Registered nurses and registered psychiatric nurses",
        label: "31301 - Registered nurses and registered psychiatric nurses",
    },
    {
        value: "31302 - Nurse practitioners ",
        label: "31302 - Nurse practitioners",
    },
    {
        value: "31303 - Physician assistants, midwives and allied health professionals  ",
        label: "31303 - Physician assistants, midwives and allied health professionals",
    },
    {
        value: "32100 - Opticians",
        label: "32100 - Opticians",
    },
    {
        value: "32101 - Licensed practical nurses",
        label: "32101 - Licensed practical nurses",
    },
    {
        value: "32102 - Paramedical occupations",
        label: "32102 - Paramedical occupations",
    },
    {
        value: "32103 - Respiratory therapists, clinical perfusionists and cardiopulmonary technologists",
        label: "32103 - Respiratory therapists, clinical perfusionists and cardiopulmonary technologists",
    },
    {
        value: "32104 - Animal health technologists and veterinary technicians",
        label: "32104 - Animal health technologists and veterinary technicians",
    },
    {
        value: "32109 - Other technical occupations in therapy and assessment",
        label: "32109 - Other technical occupations in therapy and assessment",
    },
    {
        value: "32110 - Denturists",
        label: "32110 - Denturists",
    },
    {
        value: "32111 - Dental hygienists and dental therapists",
        label: "32111 - Dental hygienists and dental therapists",
    },
    {
        value: "32112 - Dental technologists and technicians ",
        label: "32112 - Dental technologists and technicians",
    },
    {
        value: "32120 - Medical laboratory technologists",
        label: "32120 - Medical laboratory technologists",
    },
    {
        value: "32121 - Medical radiation technologists",
        label: "32121 - Medical radiation technologists",
    },
    {
        value: "32122 - Medical sonographers",
        label: "32122 - Medical sonographers",
    },
    {
        value: "32123 - Cardiology technologists and electrophysiological diagnostic technologists",
        label: "32123 - Cardiology technologists and electrophysiological diagnostic technologists",
    },
    {
        value: "32124 - Pharmacy technicians",
        label: "32124 - Pharmacy technicians",
    },
    {
        value: "32129 - Other medical technologists and technicians",
        label: "32129 - Other medical technologists and technicians",
    },
    {
        value: "32200 - Traditional Chinese medicine practitioners and acupuncturists",
        label: "32200 - Traditional Chinese medicine practitioners and acupuncturists",
    },
    {
        value: "32201 - Massage therapists",
        label: "32201 - Massage therapists",
    },
    {
        value: "32209 - Other practitioners of natural healing ",
        label: "32209 - Other practitioners of natural healing",
    },
    {
        value: "33100 - Dental assistants and dental laboratory assistants",
        label: "33100 - Dental assistants and dental laboratory assistants",
    },
    {
        value: "33101 - Medical laboratory assistants and related technical occupations",
        label: "33101 - Medical laboratory assistants and related technical occupations",
    },
    {
        value: "33102 - Nurse aides, orderlies and patient service associates",
        label: "33102 - Nurse aides, orderlies and patient service associates",
    },
    {
        value: "33103 - Pharmacy technical assistants and pharmacy assistants",
        label: "33103 - Pharmacy technical assistants and pharmacy assistants",
    },
    {
        value: "33109 - Other assisting occupations in support of health services",
        label: "33109 - Other assisting occupations in support of health services",
    },
    {
        value: "40010 - Government managers - health and social policy development and program administration",
        label: "40010 - Government managers - health and social policy development and program administration",
    },
    {
        value: "40011 - Government managers - economic analysis, policy development and program administration",
        label: "40011 - Government managers - economic analysis, policy development and program administration",
    },
    {
        value: "40012 - Government managers - education policy development and program administration",
        label: "40012 - Government managers - education policy development and program administration",
    },
    {
        value: "40019 - Other managers in public administration",
        label: "40019 - Other managers in public administration",
    },
    {
        value: "40020 - Administrators - post-secondary education and vocational training",
        label: "40020 - Administrators - post-secondary education and vocational training",
    },
    {
        value: "40021 - School principals and administrators of elementary and secondary education",
        label: "40021 - School principals and administrators of elementary and secondary education",
    },
    {
        value: "40030 - Managers in social, community and correctional services",
        label: "40030 - Managers in social, community and correctional services",
    },
    {
        value: "40040 - Commissioned police officers and related occupations in public protection services",
        label: "40040 - Commissioned police officers and related occupations in public protection services",
    },
    {
        value: "40041 - Fire chiefs and senior firefighting officers",
        label: "40041 - Fire chiefs and senior firefighting officers",
    },
    {
        value: "40042 - Commissioned officers of the Canadian Armed Forces",
        label: "40042 - Commissioned officers of the Canadian Armed Forces",
    },
    {
        value: "41100 - Judges",
        label: "41100 - Judges",
    },
    {
        value: "41101 - Lawyers and Quebec notaries",
        label: "41101 - Lawyers and Quebec notaries",
    },
    {
        value: "41200 - University professors and lecturers",
        label: "41200 - University professors and lecturers",
    },
    {
        value: "41201 - Post-secondary teaching and research assistants",
        label: "41201 - Post-secondary teaching and research assistants",
    },
    {
        value: "41210 - College and other vocational instructors",
        label: "41210 - College and other vocational instructors",
    },
    {
        value: "41220 - Secondary school teachers",
        label: "41220 - Secondary school teachers",
    },
    {
        value: "41221 - Elementary school and kindergarten teachers",
        label: "41221 - Elementary school and kindergarten teachers",
    },
    {
        value: "41300 - Social workers",
        label: "41300 - Social workers",
    },
    {
        value: "41301 - Therapists in counselling and related specialized therapies\n",
        label: "41301 - Therapists in counselling and related specialized therapies",
    },
    {
        value: "41302 - Religious leaders",
        label: "41302 - Religious leaders",
    },
    {
        value: "41310 - Police investigators and other investigative occupations",
        label: "41310 - Police investigators and other investigative occupations",
    },
    {
        value: "41311 - Probation and parole officers",
        label: "41311 - Probation and parole officers",
    },
    {
        value: "41320 - Educational counsellors",
        label: "41320 - Educational counsellors",
    },
    {
        value: "41321 - Career development practitioners and career counsellors (except education)",
        label: "41321 - Career development practitioners and career counsellors (except education)",
    },
    {
        value: "41400 - Natural and applied science policy researchers, consultants and program officers",
        label: "41400 - Natural and applied science policy researchers, consultants and program officers",
    },
    {
        value: "41401 - Economists and economic policy researchers and analysts",
        label: "41401 - Economists and economic policy researchers and analysts",
    },
    {
        value: "41402 - Business development officers and market researchers and analysts",
        label: "41402 - Business development officers and market researchers and analysts",
    },
    {
        value: "41403 - Social policy researchers, consultants and program officers",
        label: "41403 - Social policy researchers, consultants and program officers",
    },
    {
        value: "41404 - Health policy researchers, consultants and program officers",
        label: "41404 - Health policy researchers, consultants and program officers",
    },
    {
        value: "41405 - Education policy researchers, consultants and program officers",
        label: "41405 - Education policy researchers, consultants and program officers",
    },
    {
        value: "41406 - Recreation, sports and fitness policy researchers, consultants and program officers",
        label: "41406 - Recreation, sports and fitness policy researchers, consultants and program officers",
    },
    {
        value: "41407 - Program officers unique to government",
        label: "41407 - Program officers unique to government",
    },
    {
        value: "41409 - Other professional occupations in social science",
        label: "41409 - Other professional occupations in social science",
    },
    {
        value: "42100 - Police officers (except commissioned)",
        label: "42100 - Police officers (except commissioned)",
    },
    {
        value: "42101 - Firefighters",
        label: "42101 - Firefighters",
    },
    {
        value: "42102 - Specialized members of the Canadian Armed Forces",
        label: "42102 - Specialized members of the Canadian Armed Forces",
    },
    {
        value: "42200 - Paralegals and related occupations",
        label: "42200 - Paralegals and related occupations",
    },
    {
        value: "42201 - Social and community service workers",
        label: "42201 - Social and community service workers",
    },
    {
        value: "42202 - Early childhood educators and assistants",
        label: "42202 - Early childhood educators and assistants",
    },
    {
        value: "42203 - Instructors of persons with disabilities",
        label: "42203 - Instructors of persons with disabilities",
    },
    {
        value: "42204 - Religion workers",
        label: "42204 - Religion workers",
    },
    {
        value: "43100 - Elementary and secondary school teacher assistants",
        label: "43100 - Elementary and secondary school teacher assistants",
    },
    {
        value: "43109 - Other instructors",
        label: "43109 - Other instructors",
    },
    {
        value: "43200 - Sheriffs and bailiffs",
        label: "43200 - Sheriffs and bailiffs",
    },
    {
        value: "43201 - Correctional service officers",
        label: "43201 - Correctional service officers",
    },
    {
        value: "43202 - By-law enforcement and other regulatory officers ",
        label: "43202 - By-law enforcement and other regulatory officers",
    },
    {
        value: "43203 - Border services, customs, and immigration officers ",
        label: "43203 - Border services, customs, and immigration officers",
    },
    {
        value: "43204 - Operations Members of the Canadian Armed Forces",
        label: "43204 - Operations Members of the Canadian Armed Forces",
    },
    {
        value: "44100 - Home child care providers",
        label: "44100 - Home child care providers",
    },
    {
        value: "44101 - Home support workers, caregivers and related occupations ",
        label: "44101 - Home support workers, caregivers and related occupations",
    },
    {
        value: "44200 - Primary combat members of the Canadian Armed Forces",
        label: "44200 - Primary combat members of the Canadian Armed Forces",
    },
    {
        value: "45100 - Student monitors, crossing guards and related occupations",
        label: "45100 - Student monitors, crossing guards and related occupations",
    },
    {
        value: "50010 - Library, archive, museum and art gallery managers",
        label: "50010 - Library, archive, museum and art gallery managers",
    },
    {
        value: "50011 - Managers - publishing, motion pictures, broadcasting and performing arts",
        label: "50011 - Managers - publishing, motion pictures, broadcasting and performing arts",
    },
    {
        value: "50012 - Recreation, sports and fitness program and service directors",
        label: "50012 - Recreation, sports and fitness program and service directors",
    },
    {
        value: "51100 - Librarians",
        label: "51100 - Librarians",
    },
    {
        value: "51101 - Conservators and curators",
        label: "51101 - Conservators and curators",
    },
    {
        value: "51102 - Archivists",
        label: "51102 - Archivists",
    },
    {
        value: "51110 - Editors",
        label: "51110 - Editors",
    },
    {
        value: "51111 - Authors and writers (except technical)",
        label: "51111 - Authors and writers (except technical)",
    },
    {
        value: "51112 - Technical writers",
        label: "51112 - Technical writers",
    },
    {
        value: "51113 - Journalists",
        label: "51113 - Journalists",
    },
    {
        value: "51114 - Translators, terminologists and interpreters",
        label: "51114 - Translators, terminologists and interpreters",
    },
    {
        value: "51120 - Producers, directors, choreographers and related occupations",
        label: "51120 - Producers, directors, choreographers and related occupations",
    },
    {
        value: "51121 - Conductors, composers and arrangers",
        label: "51121 - Conductors, composers and arrangers",
    },
    {
        value: "51122 - Musicians and singers",
        label: "51122 - Musicians and singers",
    },
    {
        value: "52100 - Library and public archive technicians",
        label: "52100 - Library and public archive technicians",
    },
    {
        value: "52110 - Film and video camera operators",
        label: "52110 - Film and video camera operators",
    },
    {
        value: "52111 - Graphic arts technicians",
        label: "52111 - Graphic arts technicians",
    },
    {
        value: "52112 - Broadcast technicians",
        label: "52112 - Broadcast technicians",
    },
    {
        value: "52113 - Audio and video recording technicians",
        label: "52113 - Audio and video recording technicians",
    },
    {
        value: "52114 - Announcers and other broadcasters",
        label: "52114 - Announcers and other broadcasters",
    },
    {
        value: "52119 - Other technical and coordinating occupations in motion pictures, broadcasting and the performing arts",
        label: "52119 - Other technical and coordinating occupations in motion pictures, broadcasting and the performing arts",
    },
    {
        value: "52120 - Graphic designers and illustrators",
        label: "52120 - Graphic designers and illustrators",
    },
    {
        value: "52121 - Interior designers and interior decorators",
        label: "52121 - Interior designers and interior decorators",
    },
    {
        value: "53100 - Registrars, restorers, interpreters and other occupations related to museum and art galleries",
        label: "53100 - Registrars, restorers, interpreters and other occupations related to museum and art galleries",
    },
    {
        value: "53110 - Photographers",
        label: "53110 - Photographers",
    },
    {
        value: "53111 - Motion pictures, broadcasting, photography and performing arts assistants and operators",
        label: "53111 - Motion pictures, broadcasting, photography and performing arts assistants and operators",
    },
    {
        value: "53120 - Dancers",
        label: "53120 - Dancers",
    },
    {
        value: "53121 - Actors, comedians and circus performers",
        label: "53121 - Actors, comedians and circus performers",
    },
    {
        value: "53122 - Painters, sculptors and other visual artists",
        label: "53122 - Painters, sculptors and other visual artists",
    },
    {
        value: "53123 - Theatre, fashion, exhibit and other creative designers",
        label: "53123 - Theatre, fashion, exhibit and other creative designers",
    },
    {
        value: "53124 - Artisans and craftspersons",
        label: "53124 - Artisans and craftspersons",
    },
    {
        value: "53125 - Patternmakers - textile, leather and fur products",
        label: "53125 - Patternmakers - textile, leather and fur products",
    },
    {
        value: "53200 - Athletes",
        label: "53200 - Athletes",
    },
    {
        value: "53201 - Coaches",
        label: "53201 - Coaches",
    },
    {
        value: "53202 - Sports officials and referees",
        label: "53202 - Sports officials and referees",
    },
    {
        value: "54100 - Program leaders and instructors in recreation, sport and fitness",
        label: "54100 - Program leaders and instructors in recreation, sport and fitness",
    },
    {
        value: "55109 - Other performers ",
        label: "55109 - Other performers",
    },
    {
        value: "60010 - Corporate sales managers",
        label: "60010 - Corporate sales managers",
    },
    {
        value: "60020 - Retail and wholesale trade managers",
        label: "60020 - Retail and wholesale trade managers",
    },
    {
        value: "60030 - Restaurant and food service managers",
        label: "60030 - Restaurant and food service managers",
    },
    {
        value: "60031 - Accommodation service managers",
        label: "60031 - Accommodation service managers",
    },
    {
        value: "60040 - Managers in customer and personal services",
        label: "60040 - Managers in customer and personal services",
    },
    {
        value: "62010 - Retail sales supervisors",
        label: "62010 - Retail sales supervisors",
    },
    {
        value: "62020 - Food service supervisors",
        label: "62020 - Food service supervisors",
    },
    {
        value: "62021 - Executive housekeepers",
        label: "62021 - Executive housekeepers",
    },
    {
        value: "62022 - Accommodation, travel, tourism and related services supervisors",
        label: "62022 - Accommodation, travel, tourism and related services supervisors",
    },
    {
        value: "62023 - Customer and information services supervisors",
        label: "62023 - Customer and information services supervisors",
    },
    {
        value: "62024 - Cleaning supervisors",
        label: "62024 - Cleaning supervisors",
    },
    {
        value: "62029 - Other services supervisors",
        label: "62029 - Other services supervisors",
    },
    {
        value: "62100 - Technical sales specialists - wholesale trade",
        label: "62100 - Technical sales specialists - wholesale trade",
    },
    {
        value: "62101 - Retail and wholesale buyers",
        label: "62101 - Retail and wholesale buyers",
    },
    {
        value: "62200 - Chefs",
        label: "62200 - Chefs",
    },
    {
        value: "62201 - Funeral directors and embalmers",
        label: "62201 - Funeral directors and embalmers",
    },
    {
        value: "62202 - Jewellers, jewellery and watch repairers and related occupations",
        label: "62202 - Jewellers, jewellery and watch repairers and related occupations",
    },
    {
        value: "63100 - Insurance agents and brokers",
        label: "63100 - Insurance agents and brokers",
    },
    {
        value: "63101 - Real estate agents and salespersons",
        label: "63101 - Real estate agents and salespersons",
    },
    {
        value: "63102 - Financial sales representatives",
        label: "63102 - Financial sales representatives",
    },
    {
        value: "63200 - Cooks",
        label: "63200 - Cooks",
    },
    {
        value: "63201 - Butchers - retail and wholesale",
        label: "63201 - Butchers - retail and wholesale",
    },
    {
        value: "63202 - Bakers",
        label: "63202 - Bakers",
    },
    {
        value: "63210 - Hairstylists and barbers",
        label: "63210 - Hairstylists and barbers",
    },
    {
        value: "63211 - Estheticians, electrologists and related occupations",
        label: "63211 - Estheticians, electrologists and related occupations",
    },
    {
        value: "63220 - Shoe repairers and shoemakers",
        label: "63220 - Shoe repairers and shoemakers",
    },
    {
        value: "63221 - Upholsterers",
        label: "63221 - Upholsterers",
    },
    {
        value: "64100 - Retail salespersons and visual merchandisers",
        label: "64100 - Retail salespersons and visual merchandisers",
    },
    {
        value: "64101 - Sales and account representatives - wholesale trade (non-technical)",
        label: "64101 - Sales and account representatives - wholesale trade (non-technical)",
    },
    {
        value: "64200 - Tailors, dressmakers, furriers and milliners",
        label: "64200 - Tailors, dressmakers, furriers and milliners",
    },
    {
        value: "64201 - Image, social and other personal consultants",
        label: "64201 - Image, social and other personal consultants",
    },
    {
        value: "64300 - Maîtres d'hôtel and hosts/hostesses",
        label: "64300 - Maîtres d'hôtel and hosts/hostesses",
    },
    {
        value: "64301 - Bartenders",
        label: "64301 - Bartenders",
    },
    {
        value: "64310 - Travel counsellors",
        label: "64310 - Travel counsellors",
    },
    {
        value: "64311 - Pursers and flight attendants",
        label: "64311 - Pursers and flight attendants",
    },
    {
        value: "64312 - Airline ticket and service agents",
        label: "64312 - Airline ticket and service agents",
    },
    {
        value: "64313 - Ground and water transport ticket agents, cargo service representatives and related clerks",
        label: "64313 - Ground and water transport ticket agents, cargo service representatives and related clerks",
    },
    {
        value: "64314 - Hotel front desk clerks",
        label: "64314 - Hotel front desk clerks",
    },
    {
        value: "64320 - Tour and travel guides",
        label: "64320 - Tour and travel guides",
    },
    {
        value: "64321 - Casino workers",
        label: "64321 - Casino workers",
    },
    {
        value: "64322 - Outdoor sport and recreational guides",
        label: "64322 - Outdoor sport and recreational guides",
    },
    {
        value: "64400 - Customer services representatives - financial institutions",
        label: "64400 - Customer services representatives - financial institutions",
    },
    {
        value: "64401 - Postal services representatives",
        label: "64401 - Postal services representatives",
    },
    {
        value: "64409 - Other customer and information services representatives",
        label: "64409 - Other customer and information services representatives",
    },
    {
        value: "64410 - Security guards and related security service occupations",
        label: "64410 - Security guards and related security service occupations",
    },
    {
        value: "65100 - Cashiers",
        label: "65100 - Cashiers",
    },
    {
        value: "65101 - Service station attendants",
        label: "65101 - Service station attendants",
    },
    {
        value: "65102 - Store shelf stockers, clerks and order fillers",
        label: "65102 - Store shelf stockers, clerks and order fillers",
    },
    {
        value: "65109 - Other sales related occupations",
        label: "65109 - Other sales related occupations",
    },
    {
        value: "65200 - Food and beverage servers",
        label: "65200 - Food and beverage servers",
    },
    {
        value: "65201 - Food counter attendants, kitchen helpers and related support occupations",
        label: "65201 - Food counter attendants, kitchen helpers and related support occupations",
    },
    {
        value: "65202 - Meat cutters and fishmongers – retail and wholesale",
        label: "65202 - Meat cutters and fishmongers – retail and wholesale",
    },
    {
        value: "65210 - Support occupations in accommodation, travel and facilities set-up services",
        label: "65210 - Support occupations in accommodation, travel and facilities set-up services",
    },
    {
        value: "65211 - Operators and attendants in amusement, recreation and sport",
        label: "65211 - Operators and attendants in amusement, recreation and sport",
    },
    {
        value: "65220 - Pet groomers and animal care workers",
        label: "65220 - Pet groomers and animal care workers",
    },
    {
        value: "65229 - Other support occupations in personal services",
        label: "65229 - Other support occupations in personal services",
    },
    {
        value: "65310 - Light duty cleaners",
        label: "65310 - Light duty cleaners",
    },
    {
        value: "65311 - Specialized cleaners",
        label: "65311 - Specialized cleaners",
    },
    {
        value: "65312 - Janitors, caretakers and heavy-duty cleaners",
        label: "65312 - Janitors, caretakers and heavy-duty cleaners",
    },
    {
        value: "65320 - Dry cleaning, laundry and related occupations",
        label: "65320 - Dry cleaning, laundry and related occupations",
    },
    {
        value: "65329 - Other service support occupations",
        label: "65329 - Other service support occupations",
    },
    {
        value: "70010 - Construction managers",
        label: "70010 - Construction managers",
    },
    {
        value: "70011 - Home building and renovation managers",
        label: "70011 - Home building and renovation managers",
    },
    {
        value: "70012 - Facility operation and maintenance managers",
        label: "70012 - Facility operation and maintenance managers",
    },
    {
        value: "70020 - Managers in transportation",
        label: "70020 - Managers in transportation",
    },
    {
        value: "70021 - Postal and courier services managers",
        label: "70021 - Postal and courier services managers",
    },
    {
        value: "72010 - Contractors and supervisors, machining, metal forming, shaping and erecting trades and related occupations",
        label: "72010 - Contractors and supervisors, machining, metal forming, shaping and erecting trades and related occupations",
    },
    {
        value: "72011 - Contractors and supervisors, electrical trades and telecommunications occupations",
        label: "72011 - Contractors and supervisors, electrical trades and telecommunications occupations",
    },
    {
        value: "72012 - Contractors and supervisors, pipefitting trades",
        label: "72012 - Contractors and supervisors, pipefitting trades",
    },
    {
        value: "72013 - Contractors and supervisors, carpentry trades",
        label: "72013 - Contractors and supervisors, carpentry trades",
    },
    {
        value: "72014 - Contractors and supervisors, other construction trades, installers, repairers and servicers",
        label: "72014 - Contractors and supervisors, other construction trades, installers, repairers and servicers",
    },
    {
        value: "72020 - Contractors and supervisors, mechanic trades",
        label: "72020 - Contractors and supervisors, mechanic trades",
    },
    {
        value: "72021 - Contractors and supervisors, heavy equipment operator crews",
        label: "72021 - Contractors and supervisors, heavy equipment operator crews",
    },
    {
        value: "72022 - Supervisors, printing and related occupations",
        label: "72022 - Supervisors, printing and related occupations",
    },
    {
        value: "72023 - Supervisors, railway transport operations",
        label: "72023 - Supervisors, railway transport operations",
    },
    {
        value: "72024 - Supervisors, motor transport and other ground transit operators",
        label: "72024 - Supervisors, motor transport and other ground transit operators",
    },
    {
        value: "72025 - Supervisors, mail and message distribution occupations",
        label: "72025 - Supervisors, mail and message distribution occupations",
    },
    {
        value: "72100 - Machinists and machining and tooling inspectors",
        label: "72100 - Machinists and machining and tooling inspectors",
    },
    {
        value: "72101 - Tool and die makers",
        label: "72101 - Tool and die makers",
    },
    {
        value: "72102 - Sheet metal workers",
        label: "72102 - Sheet metal workers",
    },
    {
        value: "72103 - Boilermakers",
        label: "72103 - Boilermakers",
    },
    {
        value: "72104 - Structural metal and platework fabricators and fitters",
        label: "72104 - Structural metal and platework fabricators and fitters",
    },
    {
        value: "72105 - Ironworkers",
        label: "72105 - Ironworkers",
    },
    {
        value: "72106 - Welders and related machine operators",
        label: "72106 - Welders and related machine operators",
    },
    {
        value: "72200 - Electricians (except industrial and power system)",
        label: "72200 - Electricians (except industrial and power system)",
    },
    {
        value: "72201 - Industrial electricians",
        label: "72201 - Industrial electricians",
    },
    {
        value: "72202 - Power system electricians",
        label: "72202 - Power system electricians",
    },
    {
        value: "72203 - Electrical power line and cable workers",
        label: "72203 - Electrical power line and cable workers",
    },
    {
        value: "72204 - Telecommunications line and cable installers and repairers",
        label: "72204 - Telecommunications line and cable installers and repairers",
    },
    {
        value: "72205 - Telecommunications equipment installation and cable television service technicians ",
        label: "72205 - Telecommunications equipment installation and cable television service technicians",
    },
    {
        value: "72300 - Plumbers",
        label: "72300 - Plumbers",
    },
    {
        value: "72301 - Steamfitters, pipefitters and sprinkler system installers",
        label: "72301 - Steamfitters, pipefitters and sprinkler system installers",
    },
    {
        value: "72302 - Gas fitters",
        label: "72302 - Gas fitters",
    },
    {
        value: "72310 - Carpenters",
        label: "72310 - Carpenters",
    },
    {
        value: "72311 - Cabinetmakers",
        label: "72311 - Cabinetmakers",
    },
    {
        value: "72320 - Bricklayers",
        label: "72320 - Bricklayers",
    },
    {
        value: "72321 - Insulators",
        label: "72321 - Insulators",
    },
    {
        value: "72400 - Construction millwrights and industrial mechanics",
        label: "72400 - Construction millwrights and industrial mechanics",
    },
    {
        value: "72401 - Heavy-duty equipment mechanics",
        label: "72401 - Heavy-duty equipment mechanics",
    },
    {
        value: "72402 - Heating, refrigeration and air conditioning mechanics",
        label: "72402 - Heating, refrigeration and air conditioning mechanics",
    },
    {
        value: "72403 - Railway carmen/women",
        label: "72403 - Railway carmen/women",
    },
    {
        value: "72404 - Aircraft mechanics and aircraft inspectors",
        label: "72404 - Aircraft mechanics and aircraft inspectors",
    },
    {
        value: "72405 - Machine fitters",
        label: "72405 - Machine fitters",
    },
    {
        value: "72406 - Elevator constructors and mechanics",
        label: "72406 - Elevator constructors and mechanics",
    },
    {
        value: "72410 - Automotive service technicians, truck and bus mechanics and mechanical repairers",
        label: "72410 - Automotive service technicians, truck and bus mechanics and mechanical repairers",
    },
    {
        value: "72411 - Auto body collision, refinishing and glass technicians and damage repair estimators",
        label: "72411 - Auto body collision, refinishing and glass technicians and damage repair estimators",
    },
    {
        value: "72420 - Oil and solid fuel heating mechanics",
        label: "72420 - Oil and solid fuel heating mechanics",
    },
    {
        value: "72421 - Appliance servicers and repairers",
        label: "72421 - Appliance servicers and repairers",
    },
    {
        value: "72422 - Electrical mechanics",
        label: "72422 - Electrical mechanics",
    },
    {
        value: "72423 - Motorcycle, all-terrain vehicle and other related mechanics",
        label: "72423 - Motorcycle, all-terrain vehicle and other related mechanics",
    },
    {
        value: "72429 - Other small engine and small equipment repairers",
        label: "72429 - Other small engine and small equipment repairers",
    },
    {
        value: "72500 - Crane operators",
        label: "72500 - Crane operators",
    },
    {
        value: "72501 - Water well drillers",
        label: "72501 - Water well drillers",
    },
    {
        value: "72600 - Air pilots, flight engineers and flying instructors",
        label: "72600 - Air pilots, flight engineers and flying instructors",
    },
    {
        value: "72601 - Air traffic controllers and related occupations",
        label: "72601 - Air traffic controllers and related occupations",
    },
    {
        value: "72602 - Deck officers, water transport",
        label: "72602 - Deck officers, water transport",
    },
    {
        value: "72603 - Engineer officers, water transport",
        label: "72603 - Engineer officers, water transport",
    },
    {
        value: "72604 - Railway traffic controllers and marine traffic regulators",
        label: "72604 - Railway traffic controllers and marine traffic regulators",
    },
    {
        value: "72999 - Other technical trades and related occupations",
        label: "72999 - Other technical trades and related occupations",
    },
    {
        value: "73100 - Concrete finishers",
        label: "73100 - Concrete finishers",
    },
    {
        value: "73101 - Tilesetters",
        label: "73101 - Tilesetters",
    },
    {
        value: "73102 - Plasterers, drywall installers and finishers and lathers",
        label: "73102 - Plasterers, drywall installers and finishers and lathers",
    },
    {
        value: "73110 - Roofers and shinglers",
        label: "73110 - Roofers and shinglers",
    },
    {
        value: "73111 - Glaziers",
        label: "73111 - Glaziers",
    },
    {
        value: "73112 - Painters and decorators (except interior decorators)",
        label: "73112 - Painters and decorators (except interior decorators)",
    },
    {
        value: "73113 - Floor covering installers",
        label: "73113 - Floor covering installers",
    },
    {
        value: "73200 - Residential and commercial installers and servicers",
        label: "73200 - Residential and commercial installers and servicers",
    },
    {
        value: "73201 - General building maintenance workers and building superintendents ",
        label: "73201 - General building maintenance workers and building superintendents",
    },
    {
        value: "73202 - Pest controllers and fumigators",
        label: "73202 - Pest controllers and fumigators",
    },
    {
        value: "73209 - Other repairers and servicers",
        label: "73209 - Other repairers and servicers",
    },
    {
        value: "73300 - Transport truck drivers",
        label: "73300 - Transport truck drivers",
    },
    {
        value: "73301 - Bus drivers, subway operators and other transit operators",
        label: "73301 - Bus drivers, subway operators and other transit operators",
    },
    {
        value: "73310 - Railway and yard locomotive engineers",
        label: "73310 - Railway and yard locomotive engineers",
    },
    {
        value: "73311 - Railway conductors and brakemen/women",
        label: "73311 - Railway conductors and brakemen/women",
    },
    {
        value: "73400 - Heavy equipment operators",
        label: "73400 - Heavy equipment operators",
    },
    {
        value: "73401 - Printing press operators",
        label: "73401 - Printing press operators",
    },
    {
        value: "73402 - Drillers and blasters - surface mining, quarrying and construction",
        label: "73402 - Drillers and blasters - surface mining, quarrying and construction",
    },
    {
        value: "74100 - Mail and parcel sorters and related occupations",
        label: "74100 - Mail and parcel sorters and related occupations",
    },
    {
        value: "74101 - Letter carriers",
        label: "74101 - Letter carriers",
    },
    {
        value: "74102 - Couriers and messengers",
        label: "74102 - Couriers and messengers",
    },
    {
        value: "74200 - Railway yard and track maintenance workers",
        label: "74200 - Railway yard and track maintenance workers",
    },
    {
        value: "74201 - Water transport deck and engine room crew",
        label: "74201 - Water transport deck and engine room crew",
    },
    {
        value: "74202 - Air transport ramp attendants",
        label: "74202 - Air transport ramp attendants",
    },
    {
        value: "74203 - Automotive and heavy truck and equipment parts installers and servicers ",
        label: "74203 - Automotive and heavy truck and equipment parts installers and servicers",
    },
    {
        value: "74204 - Utility maintenance workers",
        label: "74204 - Utility maintenance workers",
    },
    {
        value: "74205 - Public works maintenance equipment operators and related workers",
        label: "74205 - Public works maintenance equipment operators and related workers",
    },
    {
        value: "75100 - Longshore workers",
        label: "75100 - Longshore workers",
    },
    {
        value: "75101 - Material handlers",
        label: "75101 - Material handlers",
    },
    {
        value: "75110 - Construction trades helpers and labourers",
        label: "75110 - Construction trades helpers and labourers",
    },
    {
        value: "75119 - Other trades helpers and labourers",
        label: "75119 - Other trades helpers and labourers",
    },
    {
        value: "75200 - Taxi and limousine drivers and chauffeurs",
        label: "75200 - Taxi and limousine drivers and chauffeurs",
    },
    {
        value: "75201 - Delivery service drivers and door-to-door distributors",
        label: "75201 - Delivery service drivers and door-to-door distributors",
    },
    {
        value: "75210 - Boat and cable ferry operators and related occupations",
        label: "75210 - Boat and cable ferry operators and related occupations",
    },
    {
        value: "75211 - Railway and motor transport labourers",
        label: "75211 - Railway and motor transport labourers",
    },
    {
        value: "75212 - Public works and maintenance labourers",
        label: "75212 - Public works and maintenance labourers",
    },
    {
        value: "80010 - Managers in natural resources production and fishing",
        label: "80010 - Managers in natural resources production and fishing",
    },
    {
        value: "80020 - Managers in agriculture",
        label: "80020 - Managers in agriculture",
    },
    {
        value: "80021 - Managers in horticulture",
        label: "80021 - Managers in horticulture",
    },
    {
        value: "80022 - Managers in aquaculture",
        label: "80022 - Managers in aquaculture",
    },
    {
        value: "82010 - Supervisors, logging and forestry",
        label: "82010 - Supervisors, logging and forestry",
    },
    {
        value: "82020 - Supervisors, mining and quarrying",
        label: "82020 - Supervisors, mining and quarrying",
    },
    {
        value: "82021 - Contractors and supervisors, oil and gas drilling and services",
        label: "82021 - Contractors and supervisors, oil and gas drilling and services",
    },
    {
        value: "82030 - Agricultural service contractors and farm supervisors",
        label: "82030 - Agricultural service contractors and farm supervisors",
    },
    {
        value: "82031 - Contractors and supervisors, landscaping, grounds maintenance and horticulture services",
        label: "82031 - Contractors and supervisors, landscaping, grounds maintenance and horticulture services",
    },
    {
        value: "83100 - Underground production and development miners",
        label: "83100 - Underground production and development miners",
    },
    {
        value: "83101 - Oil and gas well drillers, servicers, testers and related workers",
        label: "83101 - Oil and gas well drillers, servicers, testers and related workers",
    },
    {
        value: "83110 - Logging machinery operators",
        label: "83110 - Logging machinery operators",
    },
    {
        value: "83120 - Fishing masters and officers",
        label: "83120 - Fishing masters and officers",
    },
    {
        value: "83121 - Fishermen/women",
        label: "83121 - Fishermen/women",
    },
    {
        value: "84100 - Underground mine service and support workers ",
        label: "84100 - Underground mine service and support workers",
    },
    {
        value: "84101 - Oil and gas well drilling and related workers and services operators ",
        label: "84101 - Oil and gas well drilling and related workers and services operators",
    },
    {
        value: "84110 - Chain saw and skidder operators",
        label: "84110 - Chain saw and skidder operators",
    },
    {
        value: "84111 - Silviculture and forestry workers",
        label: "84111 - Silviculture and forestry workers",
    },
    {
        value: "84120 - Specialized livestock workers and farm machinery operators",
        label: "84120 - Specialized livestock workers and farm machinery operators",
    },
    {
        value: "84121 - Fishing vessel deckhands ",
        label: "84121 - Fishing vessel deckhands",
    },
    {
        value: "85100 - Livestock labourers",
        label: "85100 - Livestock labourers",
    },
    {
        value: "85101 - Harvesting labourers",
        label: "85101 - Harvesting labourers",
    },
    {
        value: "85102 - Aquaculture and marine harvest labourers",
        label: "85102 - Aquaculture and marine harvest labourers",
    },
    {
        value: "85103 - Nursery and greenhouse labourers",
        label: "85103 - Nursery and greenhouse labourers",
    },
    {
        value: "85104 - Trappers and hunters",
        label: "85104 - Trappers and hunters",
    },
    {
        value: "85110 - Mine labourers",
        label: "85110 - Mine labourers",
    },
    {
        value: "85111 - Oil and gas drilling, servicing and related labourers",
        label: "85111 - Oil and gas drilling, servicing and related labourers",
    },
    {
        value: "85120 - Logging and forestry labourers",
        label: "85120 - Logging and forestry labourers",
    },
    {
        value: "85121 - Landscaping and grounds maintenance labourers",
        label: "85121 - Landscaping and grounds maintenance labourers",
    },
    {
        value: "90010 - Manufacturing managers",
        label: "90010 - Manufacturing managers",
    },
    {
        value: "90011 - Utilities managers",
        label: "90011 - Utilities managers",
    },
    {
        value: "92010 - Supervisors, mineral and metal processing",
        label: "92010 - Supervisors, mineral and metal processing",
    },
    {
        value: "92011 - Supervisors, petroleum, gas and chemical processing and utilities",
        label: "92011 - Supervisors, petroleum, gas and chemical processing and utilities",
    },
    {
        value: "92012 - Supervisors, food and beverage processing",
        label: "92012 - Supervisors, food and beverage processing",
    },
    {
        value: "92013 - Supervisors, plastic and rubber products manufacturing",
        label: "92013 - Supervisors, plastic and rubber products manufacturing",
    },
    {
        value: "92014 - Supervisors, forest products processing",
        label: "92014 - Supervisors, forest products processing",
    },
    {
        value: "92015 - Supervisors, textile, fabric, fur and leather products processing and manufacturing",
        label: "92015 - Supervisors, textile, fabric, fur and leather products processing and manufacturing",
    },
    {
        value: "92020 - Supervisors, motor vehicle assembling",
        label: "92020 - Supervisors, motor vehicle assembling",
    },
    {
        value: "92021 - Supervisors, electronics and electrical products manufacturing",
        label: "92021 - Supervisors, electronics and electrical products manufacturing",
    },
    {
        value: "92022 - Supervisors, furniture and fixtures manufacturing",
        label: "92022 - Supervisors, furniture and fixtures manufacturing",
    },
    {
        value: "92023 - Supervisors, other mechanical and metal products manufacturing",
        label: "92023 - Supervisors, other mechanical and metal products manufacturing",
    },
    {
        value: "92024 - Supervisors, other products manufacturing and assembly",
        label: "92024 - Supervisors, other products manufacturing and assembly",
    },
    {
        value: "92100 - Power engineers and power systems operators",
        label: "92100 - Power engineers and power systems operators",
    },
    {
        value: "92101 - Water and waste treatment plant operators",
        label: "92101 - Water and waste treatment plant operators",
    },
    {
        value: "93100 - Central control and process operators, mineral and metal processing",
        label: "93100 - Central control and process operators, mineral and metal processing",
    },
    {
        value: "93101 - Central control and process operators, petroleum, gas and chemical processing",
        label: "93101 - Central control and process operators, petroleum, gas and chemical processing",
    },
    {
        value: "93102 - Pulping, papermaking and coating control operators",
        label: "93102 - Pulping, papermaking and coating control operators",
    },
    {
        value: "93200 - Aircraft assemblers and aircraft assembly inspectors",
        label: "93200 - Aircraft assemblers and aircraft assembly inspectors",
    },
    {
        value: "94100 - Machine operators, mineral and metal processing",
        label: "94100 - Machine operators, mineral and metal processing",
    },
    {
        value: "94101 - Foundry workers",
        label: "94101 - Foundry workers",
    },
    {
        value: "94102 - Glass forming and finishing machine operators and glass cutters",
        label: "94102 - Glass forming and finishing machine operators and glass cutters",
    },
    {
        value: "94103 - Concrete, clay and stone forming operators",
        label: "94103 - Concrete, clay and stone forming operators",
    },
    {
        value: "94104 - Inspectors and testers, mineral and metal processing",
        label: "94104 - Inspectors and testers, mineral and metal processing",
    },
    {
        value: "94105 - Metalworking and forging machine operators",
        label: "94105 - Metalworking and forging machine operators",
    },
    {
        value: "94106 - Machining tool operators",
        label: "94106 - Machining tool operators",
    },
    {
        value: "94107 - Machine operators of other metal products ",
        label: "94107 - Machine operators of other metal products",
    },
    {
        value: "94110 - Chemical plant machine operators",
        label: "94110 - Chemical plant machine operators",
    },
    {
        value: "94111 - Plastics processing machine operators",
        label: "94111 - Plastics processing machine operators",
    },
    {
        value: "94112 - Rubber processing machine operators and related workers",
        label: "94112 - Rubber processing machine operators and related workers",
    },
    {
        value: "94120 - Sawmill machine operators",
        label: "94120 - Sawmill machine operators",
    },
    {
        value: "94121 - Pulp mill, papermaking and finishing machine operators",
        label: "94121 - Pulp mill, papermaking and finishing machine operators",
    },
    {
        value: "94122 - Paper converting machine operators",
        label: "94122 - Paper converting machine operators",
    },
    {
        value: "94123 - Lumber graders and other wood processing inspectors and graders",
        label: "94123 - Lumber graders and other wood processing inspectors and graders",
    },
    {
        value: "94124 - Woodworking machine operators",
        label: "94124 - Woodworking machine operators",
    },
    {
        value: "94129 - Other wood processing machine operators",
        label: "94129 - Other wood processing machine operators",
    },
    {
        value: "94130 - Textile fibre and yarn, hide and pelt processing machine operators and workers",
        label: "94130 - Textile fibre and yarn, hide and pelt processing machine operators and workers",
    },
    {
        value: "94131 - Weavers, knitters and other fabric making occupations",
        label: "94131 - Weavers, knitters and other fabric making occupations",
    },
    {
        value: "94132 - Industrial sewing machine operators",
        label: "94132 - Industrial sewing machine operators",
    },
    {
        value: "94133 - Inspectors and graders, textile, fabric, fur and leather products manufacturing",
        label: "94133 - Inspectors and graders, textile, fabric, fur and leather products manufacturing",
    },
    {
        value: "94140 - Process control and machine operators, food and beverage processing",
        label: "94140 - Process control and machine operators, food and beverage processing",
    },
    {
        value: "94141 - Industrial butchers and meat cutters, poultry preparers and related workers",
        label: "94141 - Industrial butchers and meat cutters, poultry preparers and related workers",
    },
    {
        value: "94142 - Fish and seafood plant workers",
        label: "94142 - Fish and seafood plant workers",
    },
    {
        value: "94143 - Testers and graders, food and beverage processing",
        label: "94143 - Testers and graders, food and beverage processing",
    },
    {
        value: "94150 - Plateless printing equipment operators",
        label: "94150 - Plateless printing equipment operators",
    },
    {
        value: "94151 - Camera, platemaking and other prepress occupations",
        label: "94151 - Camera, platemaking and other prepress occupations",
    },
    {
        value: "94152 - Binding and finishing machine operators",
        label: "94152 - Binding and finishing machine operators",
    },
    {
        value: "94153 - Photographic and film processors",
        label: "94153 - Photographic and film processors",
    },
    {
        value: "94200 - Motor vehicle assemblers, inspectors and testers",
        label: "94200 - Motor vehicle assemblers, inspectors and testers",
    },
    {
        value: "94201 - Electronics assemblers, fabricators, inspectors and testers",
        label: "94201 - Electronics assemblers, fabricators, inspectors and testers",
    },
    {
        value: "94202 - Assemblers and inspectors, electrical appliance, apparatus and equipment manufacturing",
        label: "94202 - Assemblers and inspectors, electrical appliance, apparatus and equipment manufacturing",
    },
    {
        value: "94203 - Assemblers, fabricators and inspectors, industrial electrical motors and transformers",
        label: "94203 - Assemblers, fabricators and inspectors, industrial electrical motors and transformers",
    },
    {
        value: "94204 - Mechanical assemblers and inspectors",
        label: "94204 - Mechanical assemblers and inspectors",
    },
    {
        value: "94205 - Machine operators and inspectors, electrical apparatus manufacturing",
        label: "94205 - Machine operators and inspectors, electrical apparatus manufacturing",
    },
    {
        value: "94210 - Furniture and fixture assemblers, finishers, refinishers and inspectors",
        label: "94210 - Furniture and fixture assemblers, finishers, refinishers and inspectors",
    },
    {
        value: "94211 - Assemblers and inspectors of other wood products",
        label: "94211 - Assemblers and inspectors of other wood products",
    },
    {
        value: "94212 - Plastic products assemblers, finishers and inspectors",
        label: "94212 - Plastic products assemblers, finishers and inspectors",
    },
    {
        value: "94213 - Industrial painters, coaters and metal finishing process operators",
        label: "94213 - Industrial painters, coaters and metal finishing process operators",
    },
    {
        value: "94219 - Other products assemblers, finishers and inspectors",
        label: "94219 - Other products assemblers, finishers and inspectors",
    },
    {
        value: "95100 - Labourers in mineral and metal processing",
        label: "95100 - Labourers in mineral and metal processing",
    },
    {
        value: "95101 - Labourers in metal fabrication",
        label: "95101 - Labourers in metal fabrication",
    },
    {
        value: "95102 - Labourers in chemical products processing and utilities",
        label: "95102 - Labourers in chemical products processing and utilities",
    },
    {
        value: "95103 - Labourers in wood, pulp and paper processing",
        label: "95103 - Labourers in wood, pulp and paper processing",
    },
    {
        value: "95104 - Labourers in rubber and plastic products manufacturing",
        label: "95104 - Labourers in rubber and plastic products manufacturing",
    },
    {
        value: "95105 - Labourers in textile processing and cutting",
        label: "95105 - Labourers in textile processing and cutting",
    },
    {
        value: "95106 - Labourers in food and beverage processing",
        label: "95106 - Labourers in food and beverage processing",
    },
    {
        value: "95107 - Labourers in fish and seafood processing",
        label: "95107 - Labourers in fish and seafood processing",
    },
    {
        value: "95109 - Other labourers in processing, manufacturing and utilities",
        label: "95109 - Other labourers in processing, manufacturing and utilities",
    },
];
